export default __webpack_public_path__ + "static/media/u.cd712fa2.gif";